import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { DialogId } from 'account/recurring-payment/lib';
import { BasicLoader } from 'components/loaders/basic-loader';
import { StandardDialogWrapper } from './common';
import './redirecting.dialog.scss';

const RedirectingDialog = observer(() => {
  const { t } = useTranslation();
  const message = t('account.recurringPayment.redirecting');

  return (<StandardDialogWrapper id={DialogId.redirecting}>
    <>
      <BasicLoader isLoading={true} />

      <p>
        {message}
      </p>
    </>
  </StandardDialogWrapper>);
});

export default RedirectingDialog;